<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">修改密码</h1>
            <div class="u_li">
                <em class="up_lft">旧密码</em>
                <input type="text" name="other_name" v-model="oldpassword" id="other_name" value="" class="u_ipt">
            </div>
            <div class="u_li">
                <em class="up_lft">新密码</em>
                <input type="text" name="other_name" v-model="newpassword" id="other_name" value="" class="u_ipt">
            </div>
            <div class="u_li">
                <em class="up_lft">确认密码</em>
                <input type="text" name="other_name" v-model="password" id="other_name" value="" class="u_ipt">
            </div>
            <div class="u_li">
                <em class="up_lft">手机号码</em>
                <input type="text" name="other_name" v-model="userInfo.tel" id="other_name" value="" class="u_ipt">
                <button @click.prevent="sendduan" class="dxm" :disabled="!show" style="margin-left: 10px;height: 42px;line-height: 42px;border: 0;background: #f00180;border-radius: 10px;color: #ffffff;padding: 0 10px;cursor: pointer;width: 90px;">
                    <span v-show="show">获取验证码</span>
                    <span v-show="!show" class="count">{{count}} s</span>
                </button>
            </div>
            <div class="u_li">
                <em class="up_lft">验证码</em>
                <input type="number" v-model="code" class="u_ipt" value="" maxlength="6" placeholder="输入验证码">
            </div>
            <div class="u_li">
                <p style="color:#f00180;font-size:16px;">**** 密码必须六个字符，且同时包含字母和数字 ***</p>
            </div>
            <p class="u_tijiao" @click="subInfo()">提交修改</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tshare: {
            type: String,
            default: "",
        },
        str: {
            type: String,
            default: "中国(+86)",
        },
        isgj: {
            type: String,
            default: "",
        },
        is_wallet_key: {
            type: [String, Number],
        },
        check: {
            type: Boolean,
            default: true,
        },
    },
    data(){
        return{
            show: 'false',
            userInfo:[],
            count: '',
            num: 60,
            code:"",
            password:"",
            newpassword:"",
            rex: /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/,
            pas: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
            wyz: "",
            oldpassword:"",
            gj: this.str,
        }
    },
    mounted(){
        this.getUserInfo();
    },
    methods:{
        getUserInfo(){
            var params = {};
            params.id = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getUser.getUserInfo(params).then(res=>{
                this.userInfo = res.result;
            });
        },
        sendduan () {
            var _this = this;
            this.$api.getLogin.sendCode({
                tel: this.userInfo.tel,
                quhao: this.quhao,
            }).then((res) => {
                // 验证码倒计时
                if (!this.timer) {
                    this.count = 60;
                    this.show = false;
                    this.wyz = res.result;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= 60) {
                            this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            });
        },
        subInfo() {
            if (this.password == "") {
                this.$alert('密码不能为空', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            } else if (!this.$fnc.regexp(this.pas, this.password)) {
                this.$alert('密码非法,请从新输入', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            } else if (this.newpassword != this.password) {
                this.$alert('两次输入的不一致,请从新输入', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            }
            var params = {};
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            params.new_password = this.$getCode(this.password);
            params.code = this.code;
            params.unicode = this.wyz;
            params.tel = this.userInfo.tel;
            params.quhao = this.gj.replace(/[^0-9]/gi, "");
            params.old_password = this.$getCode(this.oldpassword);
            this.$api.getUser.changePassword(params).then((res) => {
                if (res.code == 200) {
                    this.$alert('操作成功', '提示', {
                        confirmButtonText: '确定',
                    });
                    localStorage.clear();
                    this.$router.push({name:"Login"})
                    // this.$router.go(-1);
                    // this.$toast.success("操作成功");
                    // setTimeout(() => {
                    //     this.$store.dispatch("getUser");
                    //     this.toBack();
                    // }, 3000);
                }
            });
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
.u_avas{overflow:hidden;height:70px;line-height:25px;padding:15px 0 0 0;zoom:1;position:relative;}
.ava_ipt{position:absolute;left:0;top:0;width:80px;height:80px;z-index:2;filter:alpha(opacity=0);opacity:0;}
.ava{width:55px;height:55px;float:left;margin-right:20px;border-radius:50%;}
.ua_name{font-size:30px;color:#000;font-weight: bold;margin-top:5px;}
.ua_id{font-size:10px;color:#999;}
.u_li{padding:10px 10px 10px 90px;line-height:42px;height:42px;font-size:14px;position:relative;overflow:hidden;display:block;zoom:1;}
.up_lft{color:#000;font-size:14px;position:absolute;left:0;top:10px;line-height:42px;}
.u_ipt{border:0;height:42px;line-height:42px;float:left;font-size:14px;width:200px;border:1px solid #eee;padding:0 10px;}
.u_tijiao{background-color:#f00180;line-height:50px;text-align:center;color:#ffffff;margin:20px 0;display:block;cursor:pointer;width:300px;margin-left:90px;font-size:16px;}
.u_logout{background-color:#fafafa;line-height:45px;text-align:center;color:#888;margin:20px 0;display:inline-block;width:200px;}
.u_lbl{vertical-align:middle;padding-right:20px;line-height:42px;}
.u_date{width:120px;cursor:pointer;border:1px solid #eee;line-height:42px;height:42px;margin-right:5px;}
</style>


// WEBPACK FOOTER //
// src/components/common/user-password.vue